module.exports = __webpack_public_path__ + "img/Dashboard copy.3647babc.svg";